import React from "react";

function ApplyNew(){
    return(
        <div className="form-content">      
            <ul>
                <li>
                    <label>Mode Of Payment (Payment gateway) <span>*</span></label>
                    <select>
                        <option>NEFT</option>
                        <option>RTGS</option>
                    </select>
                </li>
                <li>
                    <label>Tax Payer Type <span>*</span></label>
                    <select>
                      <option>SEZ</option>
                      <option>NON SEZ</option>
                    </select>
                </li>
                <li>
                    <label>Upload SEZ Declaration </label>
                    <input type="file" />
                </li>
                <li>
                    <label>GST Number <span>*</span></label><input type="text" placeholder="GST Number" />
                </li>
                <li>
                    <label>Payment Amount <span>*</span></label><input type="text" placeholder="Payment Amount" />
                </li>
                <li>
                    <label>Proceed to Payment <span>*</span></label><input type="text" placeholder="Proceed to Payment" />
                </li>
                <li>
                    <label>No of Years <span>*</span></label><input type="text" placeholder="No of Years" />
                </li>
                <li className="flex100">
                    <label>Document Upload (as per legal from)</label>
                </li>
                <li>
                    <label>Letter of Authority <span>*</span></label><input type="file" />
                </li>
                <li>
                    <label>Audited Annual Financial Statement / Report (latest available) <span>*</span></label><input type="file" />
                </li>
                <li>
                    <label>Consolidated Audited Annual Financial Statement / Report of the direct parent (If Any) <span>*</span></label><input type="file" />
                </li>
                <li>
                    <label>Consolidated Audited Annual Financial Statement / Report of the ultimate parent (If Any) <span>*</span></label><input type="file" />
                </li>
                <li>
                    <label>Statutory Auditor’s Certificate (if required) <span>*</span></label><input type="file" />
                </li>
                <li>
                    <label>Shareholding pattern on company’s letterhead <span>*</span></label><input type="file" />
                </li>
            </ul>
    </div>
    );
}export default ApplyNew